import { render, staticRenderFns } from "./RMPaymentsPeriodSelectors.vue?vue&type=template&id=1e171960&"
import script from "./RMPaymentsPeriodSelectors.vue?vue&type=script&lang=js&"
export * from "./RMPaymentsPeriodSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports